"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionItemsTable = TransactionItemsTable;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var console_1 = require("../../../../../reducers/slices/console");
var item_activity_table_1 = require("../../items/components/itemActivityTable/item_activity_table");
function TransactionItemsTable() {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Item Transactions"));
    }, [dispatch]);
    return (0, jsx_runtime_1.jsx)(item_activity_table_1.ItemActivityTable, { show_export: true });
}
